export const STRIPE_TERMINAL_S700_URL = 'https://stripe.com/terminal/s700';

// The images are from here: https://stripe.com/terminal/devices
export const STRIPE_TERMINAL_READER_IMAGES: Record<string, string> = {
  simulated_stripe_s700:
    'https://images.stripeassets.com/fzn2n1nzq965/3fFobFbTyXueMGNmKDECxp/4349382b59d14f8db7707e1162f85dcc/Property_1_S700.png',
  simulated_stripe_s710:
    'https://images.stripeassets.com/fzn2n1nzq965/3fFobFbTyXueMGNmKDECxp/4349382b59d14f8db7707e1162f85dcc/Property_1_S700.png',
  simulated_wisepos_e:
    'https://images.stripeassets.com/fzn2n1nzq965/3ywge4aKzsVRNFLu43sUKZ/ffc0c56ccfaa227a85a1691f1928f11e/Property_1_WisePOS-E.png',

  stripe_s700:
    'https://images.stripeassets.com/fzn2n1nzq965/3fFobFbTyXueMGNmKDECxp/4349382b59d14f8db7707e1162f85dcc/Property_1_S700.png',
  stripe_s710:
    'https://images.stripeassets.com/fzn2n1nzq965/3fFobFbTyXueMGNmKDECxp/4349382b59d14f8db7707e1162f85dcc/Property_1_S700.png',
  stripe_m2:
    'https://images.stripeassets.com/fzn2n1nzq965/mnfl223akEEJrvfGQriXT/14092881b660553efa84a3e40bf661f8/Property_1_M2.png',
  bbpos_wisepos_e:
    'https://images.stripeassets.com/fzn2n1nzq965/3ywge4aKzsVRNFLu43sUKZ/ffc0c56ccfaa227a85a1691f1928f11e/Property_1_WisePOS-E.png',
  bbpos_wisepad3:
    'https://images.stripeassets.com/fzn2n1nzq965/mA5anW5Cih5rHZpkHNObR/08a698270ca595ddd310959875793ae2/Property_1_WisePad-3.png',
  tap_to_pay_on_iphone:
    'https://images.stripeassets.com/fzn2n1nzq965/3zzrFKv3eLgQV9VBQSvwRL/c91053846458697dbc66ef3ecacc946c/Tap_to_Pay_iOS_US.png',
  tap_to_pay_on_android:
    'https://images.stripeassets.com/fzn2n1nzq965/78kFQT9lTwShAMTaLA90hM/3a80b1898b344c15be369f085224880e/Property_1_TTP_Android.png',
  verifone_v660p:
    'https://images.stripeassets.com/fzn2n1nzq965/ETY3dDAgIpuS2GdowU2tC/a68b490ba441b888834088578d38ee01/Property_1_V660p.png',
  verifone_ux700:
    'https://images.stripeassets.com/fzn2n1nzq965/4Rwmn1Cxvl2OnxS47zqOyd/a62417f492bc37b7393afcdd4d59b0d0/Property_1_UX700.png',
  verifone_m425:
    'https://images.stripeassets.com/fzn2n1nzq965/3FyAur9OYFWJw0xxyJZod0/844a22122ebb86792047c0191bd81e32/Property_1_M425.png',
  verifone_p630:
    'https://images.stripeassets.com/fzn2n1nzq965/7Ay6LQ8Iluqbf77sU5Xsqo/5bd916d28eb3d138980b9e78b7ea463d/Property_1_P630.png',
};

// Policy shown alongside the AI Connect surfaces, where connecting is stated to constitute
// acceptance. Points at the published privacy policy; the dedicated customer-facing AI usage
// policy (FEAT-214 D6) is still a Product/Legal deliverable and has no URL yet.
export const KILO_PRIVACY_POLICY_URL = 'https://usekilo.com/privacy-policy/';
